"use client";
import React from "react";
import ThemeContext, { ThemeMode } from "@/contexts/theme-context";

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [mode, setMode] = React.useState<ThemeMode>("light");
  const value = React.useMemo(() => ({ mode, setMode }), [mode]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
